"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var CBOR = require("@wireapp/cbor");
var ArrayUtil_1 = require("../util/ArrayUtil");
var ClassUtil_1 = require("../util/ClassUtil");
var MemoryUtil_1 = require("../util/MemoryUtil");
var DecryptError_1 = require("../errors/DecryptError");
var DerivedSecrets_1 = require("../derived/DerivedSecrets");
var KeyPair_1 = require("../keys/KeyPair");
var CipherMessage_1 = require("../message/CipherMessage");
var Envelope_1 = require("../message/Envelope");
var PreKeyMessage_1 = require("../message/PreKeyMessage");
var ChainKey_1 = require("./ChainKey");
var RecvChain_1 = require("./RecvChain");
var RootKey_1 = require("./RootKey");
var SendChain_1 = require("./SendChain");
var Session_1 = require("./Session");
var SessionState = (function () {
    function SessionState() {
        this.prev_counter = -1;
        this.recv_chains = [];
        this.root_key = new RootKey_1.default();
        this.send_chain = new SendChain_1.default();
    }
    SessionState.init_as_alice = function (alice_identity_pair, alice_base, bob_pkbundle) {
        return __awaiter(this, void 0, void 0, function () {
            var master_key, derived_secrets, rootkey, chainkey, recv_chains, send_ratchet, _a, rok, chk, send_chain, state;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        master_key = ArrayUtil_1.default.concatenate_array_buffers([
                            alice_identity_pair.secret_key.shared_secret(bob_pkbundle.public_key),
                            alice_base.secret_key.shared_secret(bob_pkbundle.identity_key.public_key),
                            alice_base.secret_key.shared_secret(bob_pkbundle.public_key),
                        ]);
                        derived_secrets = DerivedSecrets_1.default.kdf_without_salt(master_key, 'handshake');
                        MemoryUtil_1.default.zeroize(master_key);
                        rootkey = RootKey_1.default.from_cipher_key(derived_secrets.cipher_key);
                        chainkey = ChainKey_1.default.from_mac_key(derived_secrets.mac_key, 0);
                        recv_chains = [RecvChain_1.default.new(chainkey, bob_pkbundle.public_key)];
                        return [4, KeyPair_1.default.new()];
                    case 1:
                        send_ratchet = _b.sent();
                        _a = rootkey.dh_ratchet(send_ratchet, bob_pkbundle.public_key), rok = _a[0], chk = _a[1];
                        send_chain = SendChain_1.default.new(chk, send_ratchet);
                        state = ClassUtil_1.default.new_instance(SessionState);
                        state.recv_chains = recv_chains;
                        state.send_chain = send_chain;
                        state.root_key = rok;
                        state.prev_counter = 0;
                        return [2, state];
                }
            });
        });
    };
    SessionState.init_as_bob = function (bob_ident, bob_prekey, alice_ident, alice_base) {
        var master_key = ArrayUtil_1.default.concatenate_array_buffers([
            bob_prekey.secret_key.shared_secret(alice_ident.public_key),
            bob_ident.secret_key.shared_secret(alice_base),
            bob_prekey.secret_key.shared_secret(alice_base),
        ]);
        var derived_secrets = DerivedSecrets_1.default.kdf_without_salt(master_key, 'handshake');
        MemoryUtil_1.default.zeroize(master_key);
        var rootkey = RootKey_1.default.from_cipher_key(derived_secrets.cipher_key);
        var chainkey = ChainKey_1.default.from_mac_key(derived_secrets.mac_key, 0);
        var send_chain = SendChain_1.default.new(chainkey, bob_prekey);
        var state = ClassUtil_1.default.new_instance(SessionState);
        state.recv_chains = [];
        state.send_chain = send_chain;
        state.root_key = rootkey;
        state.prev_counter = 0;
        return state;
    };
    SessionState.prototype.ratchet = function (ratchet_key) {
        return __awaiter(this, void 0, void 0, function () {
            var new_ratchet, _a, recv_root_key, recv_chain_key, _b, send_root_key, send_chain_key, recv_chain, send_chain, index;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4, KeyPair_1.default.new()];
                    case 1:
                        new_ratchet = _c.sent();
                        _a = this.root_key.dh_ratchet(this.send_chain.ratchet_key, ratchet_key), recv_root_key = _a[0], recv_chain_key = _a[1];
                        _b = recv_root_key.dh_ratchet(new_ratchet, ratchet_key), send_root_key = _b[0], send_chain_key = _b[1];
                        recv_chain = RecvChain_1.default.new(recv_chain_key, ratchet_key);
                        send_chain = SendChain_1.default.new(send_chain_key, new_ratchet);
                        this.root_key = send_root_key;
                        this.prev_counter = this.send_chain.chain_key.idx;
                        this.send_chain = send_chain;
                        this.recv_chains.unshift(recv_chain);
                        if (this.recv_chains.length > Session_1.default.MAX_RECV_CHAINS) {
                            for (index = Session_1.default.MAX_RECV_CHAINS; index < this.recv_chains.length; index++) {
                                MemoryUtil_1.default.zeroize(this.recv_chains[index]);
                            }
                            this.recv_chains = this.recv_chains.slice(0, Session_1.default.MAX_RECV_CHAINS);
                        }
                        return [2];
                }
            });
        });
    };
    SessionState.prototype.encrypt = function (identity_key, pending, tag, plaintext) {
        var msgkeys = this.send_chain.chain_key.message_keys();
        var message = CipherMessage_1.default.new(tag, this.send_chain.chain_key.idx, this.prev_counter, this.send_chain.ratchet_key.public_key, msgkeys.encrypt(plaintext));
        if (pending) {
            message = PreKeyMessage_1.default.new(pending[0], pending[1], identity_key, message);
        }
        var env = Envelope_1.default.new(msgkeys.mac_key, message);
        this.send_chain.chain_key = this.send_chain.chain_key.next();
        return env;
    };
    SessionState.prototype.decrypt = function (envelope, msg) {
        return __awaiter(this, void 0, void 0, function () {
            var idx, rc, mks, plain, _a, chk, mk, mks, plain;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        idx = this.recv_chains.findIndex(function (chain) { return chain.ratchet_key.fingerprint() === msg.ratchet_key.fingerprint(); });
                        if (!(idx === -1)) return [3, 2];
                        return [4, this.ratchet(msg.ratchet_key)];
                    case 1:
                        _b.sent();
                        idx = 0;
                        _b.label = 2;
                    case 2:
                        rc = this.recv_chains[idx];
                        if (msg.counter < rc.chain_key.idx) {
                            return [2, rc.try_message_keys(envelope, msg)];
                        }
                        else if (msg.counter == rc.chain_key.idx) {
                            mks = rc.chain_key.message_keys();
                            if (!envelope.verify(mks.mac_key)) {
                                throw new DecryptError_1.default.InvalidSignature("Envelope verification failed for message with counters in sync at '" + msg.counter + "'. The received message was possibly encrypted for another client.", DecryptError_1.default.CODE.CASE_206);
                            }
                            plain = mks.decrypt(msg.cipher_text);
                            rc.chain_key = rc.chain_key.next();
                            return [2, plain];
                        }
                        else {
                            _a = rc.stage_message_keys(msg), chk = _a[0], mk = _a[1], mks = _a[2];
                            if (!envelope.verify(mk.mac_key)) {
                                throw new DecryptError_1.default.InvalidSignature("Envelope verification failed for message with counter ahead. Message index is '" + msg.counter + "' while receive chain index is '" + rc.chain_key.idx + "'.", DecryptError_1.default.CODE.CASE_207);
                            }
                            plain = mk.decrypt(msg.cipher_text);
                            rc.chain_key = chk.next();
                            rc.commit_message_keys(mks);
                            return [2, plain];
                        }
                        return [2];
                }
            });
        });
    };
    SessionState.prototype.serialise = function () {
        var encoder = new CBOR.Encoder();
        this.encode(encoder);
        return encoder.get_buffer();
    };
    SessionState.deserialise = function (buf) {
        return SessionState.decode(new CBOR.Decoder(buf));
    };
    SessionState.prototype.encode = function (encoder) {
        encoder.object(4);
        encoder.u8(0);
        encoder.array(this.recv_chains.length);
        this.recv_chains.map(function (rch) { return rch.encode(encoder); });
        encoder.u8(1);
        this.send_chain.encode(encoder);
        encoder.u8(2);
        this.root_key.encode(encoder);
        encoder.u8(3);
        return encoder.u32(this.prev_counter);
    };
    SessionState.decode = function (decoder) {
        var self = ClassUtil_1.default.new_instance(SessionState);
        var nprops = decoder.object();
        for (var index = 0; index <= nprops - 1; index++) {
            switch (decoder.u8()) {
                case 0: {
                    self.recv_chains = [];
                    var len = decoder.array();
                    while (len--) {
                        self.recv_chains.push(RecvChain_1.default.decode(decoder));
                    }
                    break;
                }
                case 1: {
                    self.send_chain = SendChain_1.default.decode(decoder);
                    break;
                }
                case 2: {
                    self.root_key = RootKey_1.default.decode(decoder);
                    break;
                }
                case 3: {
                    self.prev_counter = decoder.u32();
                    break;
                }
                default: {
                    decoder.skip();
                }
            }
        }
        return self;
    };
    return SessionState;
}());
exports.default = SessionState;



//////////////////
// WEBPACK FOOTER
// ../proteus/dist/session/SessionState.js
// module id = 211
// module chunks = 0 1